import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';
import { getCodesFromLocale } from './utils';
export function useFetchMessagesByLocale(locale, fetchLanguageFile) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    messages = _useState2[0],
    setMessages = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  useEffect(function () {
    function startToFetchMessagesByLocale() {
      return _startToFetchMessagesByLocale.apply(this, arguments);
    }
    function _startToFetchMessagesByLocale() {
      _startToFetchMessagesByLocale = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _getCodesFromLocale, language, country, finalLocale, languageFile, newMessages;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _getCodesFromLocale = getCodesFromLocale(locale), language = _getCodesFromLocale.language, country = _getCodesFromLocale.country; // don't load English messages
              if (!(language === 'en')) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.prev = 3;
              setIsLoading(true);
              finalLocale = country ? "".concat(language, "-").concat(country) : language;
              _context.next = 8;
              return fetchLanguageFile(finalLocale);
            case 8:
              languageFile = _context.sent;
              newMessages = languageFile.default || languageFile;
              setMessages(newMessages);
              _context.next = 15;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](3);
            case 15:
              _context.prev = 15;
              setIsLoading(false);
              return _context.finish(15);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 13, 15, 18]]);
      }));
      return _startToFetchMessagesByLocale.apply(this, arguments);
    }
    startToFetchMessagesByLocale();
  }, [fetchLanguageFile, locale]);
  return {
    messages: messages,
    isLoading: isLoading
  };
}
var WithMessages = function WithMessages(_ref) {
  var children = _ref.children,
    fetchLanguageFile = _ref.fetchLanguageFile;
  var intl = useIntl();
  var _useFetchMessagesByLo = useFetchMessagesByLocale(intl.locale, fetchLanguageFile),
    messages = _useFetchMessagesByLo.messages;
  return /*#__PURE__*/React.createElement(IntlProvider, {
    messages: messages,
    locale: intl.locale
  }, children);
};
export function WithCustomIntlProvider(Component, fetchLanguageFile) {
  return function (props) {
    return /*#__PURE__*/React.createElement(WithMessages, {
      fetchLanguageFile: fetchLanguageFile
    }, /*#__PURE__*/React.createElement(Component, props));
  };
}